import React from "react";
import Tag from "components/Tag";
import { useAllUploadingFiles } from "features/ResearchHub/hooks/useAllUploadingFiles";
import { LoadingIcon } from "components/LoadingIcon";

/**
 * Component that displays uploading tags for all papers currently being uploaded.
 * Automatically shows/hides based on the global upload state.
 */
export const UploadingTags: React.FC = () => {
  // Get all uploading files
  const uploadingFiles = useAllUploadingFiles();

  if (uploadingFiles.length === 0) {
    return null;
  }

  return (
    <>
      {uploadingFiles.map((fileInfo) => (
        <Tag
          key={fileInfo.filename}
          size="sm"
          icon=<LoadingIcon size={16} className="text-fg-base" />
          label=<span className="truncate text-fg-base max-w-30">
            {fileInfo.filename}
          </span>
        />
      ))}
    </>
  );
};
